import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "background-image full" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = { class: "nav" }
const _hoisted_5 = { class: "search" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Oops, something went wrong")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oztix_logo = _resolveComponent("oztix-logo")!
  const _component_nav_menu = _resolveComponent("nav-menu")!
  const _component_search = _resolveComponent("search")!
  const _component_the_footer = _resolveComponent("the-footer")!

  return (_openBlock(), _createElementBlock("div", {
    class: "app",
    style: _normalizeStyle({
      background: `
          url(${require('@/assets/pattern-right.svg')}) top right / 50% repeat-y,
          url(${require('@/assets/pattern-left.svg')}) top left / 50% repeat-y
          `,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        "aria-hidden": "true",
        alt: "",
        src: require('@/assets/pattern-top.svg')
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_oztix_logo)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_nav_menu)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_search, {
          query: _ctx.searchQuery ? _ctx.searchQuery.q : ''
        }, null, 8, ["query"])
      ])
    ]),
    _createElementVNode("main", {
      role: "main",
      id: "main",
      class: _normalizeClass({ full: _ctx.full })
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_6
      ])
    ], 2),
    _createVNode(_component_the_footer)
  ], 4))
}